import { theme } from '@hhgtech/hhg-components'
import { Flex, Tooltip } from '@mantine/core'
import { useDueDateStore } from 'components/templates/dueDateCalculator/utils'
import { useIntl } from 'react-intl'
import DoubleArrowIcon from './doubleArrowIcon'
import RecalculationIcon from './recalculationIcon'

const RecalculateBtnWithTooltip = () => {
  const { formatMessage: f } = useIntl()
  const { isRecalculate, setIsRecalculate } = useDueDateStore()

  const tracking = {
    'data-event-category': 'Health Tool',
    'data-event-action': 'Due Date - Result Page',
    'data-event-label': isRecalculate ? 'View Result' : 'Re-calculate',
  }

  const renderedContent = (
    <Flex
      w={40}
      h={40}
      pos="absolute"
      top={40}
      left={-40}
      bg={theme.colors.primaryBase}
      align="center"
      justify="center"
      sx={{ borderRadius: '8px 0 0 8px', cursor: 'pointer' }}
      onClick={() => setIsRecalculate(!isRecalculate)}
      className="pointer-event-child-none"
      {...tracking}
    >
      {isRecalculate ? <DoubleArrowIcon /> : <RecalculationIcon />}
    </Flex>
  )

  if (isRecalculate) return renderedContent

  return (
    <Tooltip
      withinPortal
      withArrow
      label={f({
        id: 'tools.recalculate',
        defaultMessage: 'Recalculate',
      })}
      position="left"
      styles={{
        tooltip: {
          fontSize: 12,
          color: theme.colors.gray600,
          '::before': {
            content: '""',
            position: 'absolute',
            width: '0.25rem',
            height: '0.25rem',
            backgroundColor: theme.colors.white,
            right: '-2px',
            top: '50%',
            transform: 'translateY(-50%) rotate(45deg)',
            boxShadow: '0px 0px 2px 0px rgba(0, 0, 0, 0.1)',
            zIndex: -2,
          },
        },
        arrow: {
          transform: 'none !important',
          top: '0 !important',
          left: '0 !important',
          height: '100% !important',
          width: '100% !important',
          borderRadius: '4px !important',
          zIndex: -1,
          backgroundColor: theme.colors.white,
          boxShadow: '-1px 0px 2px 0px rgba(0, 0, 0, 0.1)',
        },
      }}
    >
      {renderedContent}
    </Tooltip>
  )
}

export default RecalculateBtnWithTooltip
